import React from 'react';

import PropTypes from 'prop-types';

export const productBandaLarga = ({ fillColor }) => (
    <svg viewBox='0 0 34 35' xmlns='http://www.w3.org/2000/svg'>
        <g fill={fillColor}>
            <path d='M20.48 1.435c-1.943-1.913-5.313-1.913-7.387 0L0 14.322v20.67h33.704V14.32L20.48 1.435zM31.11 32.44H2.594V15.47L15.037 3.222c1.037-1.02 2.722-1.02 3.63 0L31.11 15.47v16.97zm-14.258-22.2c-5.574 0-10.24 4.464-10.24 10.078 0 5.486 4.536 10.08 10.24 10.08 5.704 0 10.24-4.466 10.24-10.08 0-5.486-4.666-10.08-10.24-10.08zm2.074 8.93h-4.148c.26-4.338 1.555-6.635 2.074-6.635.518 0 1.944 2.297 2.074 6.635zm-2.074 8.93c-.52 0-1.945-2.296-2.074-6.634h4.148c-.13 4.338-1.556 6.635-2.074 6.635zm-3.24-14.927c-.65 1.66-1.038 3.828-1.168 5.997h-3.5c.52-2.68 2.204-4.848 4.667-5.997zm-4.668 8.293h3.5c.13 2.17.52 4.338 1.167 5.997-2.462-1.02-4.277-3.317-4.666-5.997zm11.15 5.997c.647-1.66 1.036-3.828 1.165-5.997h3.5c-.39 2.68-2.204 4.976-4.667 5.997zm4.665-8.293h-3.5c-.13-2.17-.52-4.338-1.167-5.997 2.463 1.15 4.148 3.318 4.666 5.997z' />
        </g>
    </svg>
);

productBandaLarga.propTypes = {
    fillColor: PropTypes.string.isRequired
};

export default productBandaLarga;
